import { useEffect } from "react";
import { input } from "../../helper";
import "./tfCard.css";
import Option from "../Option";
import Question from "../Question";

export default function TFCard({ data, number, color = "", setCorrectAnswer }) {
  const handleClick = (e) => {
    setCorrectAnswer(e.target.value);
  };

  useEffect(() => {
    const radios = document.querySelectorAll(".question-fields .radio");
    radios.forEach((radio) => {
      radio.checked = false;
    });
  }, [number]);

  return (
    <Question
      color={color}
      index={number}
      question={data}
      label={"True or False"}
    >
      {data.options.map((option, i) => (
        <Option
          key={i}
          type="radio"
          option={option}
          select={handleClick}
          styles={input(color)}
          isTF={true}
          checkMarkStyles={input(color, i)}
        />
      ))}
    </Question>
  );
}
